import migrate from './database/migrations.js'
import compile from './lib/ajv.js'
import { sql } from 'kysely'
import { extractFullMarkdown } from './lib/markdown.js'
import { addFrontMatter } from './lib/frontmatter.js'
import { getDatabaseClient } from './database/client.js'
import {
	filterFrontmatterFields,
	findFrontmatterField,
	getFrontmatterValue,
	getFrontmatterValues,
	resolveFieldPaths,
	setFrontmatterValue,
	unsetFrontmatterValue,
	savePieceAsset,
} from './pieces/index.js'

export * from './database/tables/index.js'
export * from './pieces/index.js'
export * from './llm/google.js'
export * from './storage/index.js'

export {
	getDatabaseClient,
	migrate,
	sql,
	compile,
	extractFullMarkdown,
	addFrontMatter,
	filterFrontmatterFields,
	findFrontmatterField,
	getFrontmatterValue,
	getFrontmatterValues,
	resolveFieldPaths,
	setFrontmatterValue,
	unsetFrontmatterValue,
	savePieceAsset,
}
